import $ from 'jquery';
// import { breakpoints } from './_site';

export const activateCardForm = ($el) => {
    var $currentCard = $el.closest('.card--form'),
        cardFormClass = 'card--form',
        cardFormActiveClass = cardFormClass + '--active',
        $otherActiveCards = $('.' + cardFormActiveClass);

    $otherActiveCards.not($currentCard).removeClass(cardFormActiveClass);
    $currentCard.addClass(cardFormActiveClass);
};

export const binds = () => {
    $('#wrapper').on(
        'focus.card',
        '.card--form input, .card--form textarea',
        function(event) {
            activateCardForm($(this));
        }
    );
};
